import styles from "./Hero.module.css";
import hero from "../../assets/images/Hero/hero.avif";
function Hero() {
  return (
    <div
      className={styles.heroContainer}
      style={{ backgroundImage: `url(${hero})` }}
    >
      <div className={styles.overlay}>
        <div className={styles.heroContent}>
          <p className={styles.heroPretitle}>
            Feinster Genuss für den schönsten Tag.
          </p>
          <h1 className={styles.heroTitle}>Wedding Cuisine</h1>
          <p className={styles.heroSubtitle}>So einzigartig wie eure Liebe.</p>
          <div className={styles.heroButtons}>
            <div
              role="button"
              onClick={() => (window.location.href = "#card-menu")}
            >
              Unsere Angebote
            </div>
            <div
              role="button"
              onClick={() => (window.location.href = "#card-impression")}
            >
              Impressionen
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
